export default "__VITE_ASSET__CAvATNCN__"